"use strict";

exports.__esModule = true;
exports.WidgetsContext = void 0;
exports.withWidgetsContext = withWidgetsContext;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var WidgetsContext = exports.WidgetsContext = /*#__PURE__*/_react["default"].createContext({
  dashboardWidgets: [{}],
  reportWidgets: [{}],
  operatorPanelWidgets: [{}],
  deviceDetailsWidgets: [{}],
  alertWidgets: [{}],
  auditLogWidgets: [{}],
  historicalPartCountWidgets: [{}]
});
function withWidgetsContext(Component) {
  return function (props) {
    var widgets = _react["default"].useContext(WidgetsContext);
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      widgets: widgets
    }));
  };
}